import React, { FC } from 'react';

import { ComponentFilesField } from 'components/component-fields/ComponentFilesField';

import { ComponentDatasheetSection } from './ComponentDatasheetSection';

const Files: FC = () => {
    return (
        <ComponentDatasheetSection title="Files">
            <ComponentFilesField editable={true} />
        </ComponentDatasheetSection>
    );
};

export { Files };
